import { Routes } from '@angular/router';
import { LoginComponent } from './component/login/login.component';
import { PasswordResetComponent } from './component/password-reset/password-reset.component';
import { PasswordChangeComponent } from './component/password-change/password-change.component';
import { SingleSignOnComponent } from './component/single-sign-on/single-sign-on.component';
import { LoggedOutComponent } from './component/logged-out/logged-out.component';
import { LoginLegacyComponent } from './component/login-legacy/login-legacy.component';

export const SessionRoutes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'logindaephoh7noop2Goi1zu9',
    component: LoginLegacyComponent,
  },
  {
    path: 'sso',
    component: SingleSignOnComponent,
  },
  {
    path: 'logged-out',
    component: LoggedOutComponent,
  },
];
